import React from 'react';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as libraryActions from '~/library/actions';
import StringService from '~/utils/StringService';
import Helpers from '~/utils/Helpers';
import { Table, Thead, Th, Tr, Td } from 'SourceClear-Reactable';
import CvssService from '~/utils/CvssService';
type LibraryViewVulnerabilitiesProps = {
  libraryState: object;
  actions: object;
  vcPageState: object;
};
class LibraryViewVulnerabilities extends React.Component<LibraryViewVulnerabilitiesProps, {}> {
  componentDidMount() {
    const { libraryState } = this.props;
    const { componentId, vulnerabilityFetchError = false } = libraryState;
    if (+componentId && vulnerabilityFetchError) {
      this.props.actions.fetchVulnerabilities(+componentId);
    }
  }
  updateFilter = e => {
    let filter = e.target.value;
    this.props.actions.updateVulnerabilityFilter(filter.toLowerCase());
  };
  getFilteredVulnerabilities() {
    const { libraryState } = this.props;
    const { vulnerabilityFilter = '', vulnerabilities = [] } = libraryState;
    if (!vulnerabilityFilter) {
      return vulnerabilities;
    }
    return vulnerabilities.filter(vuln => {
      let { title } = vuln;
      return title.toLowerCase().indexOf(vulnerabilityFilter) > -1;
    });
  }
  render() {
    const { libraryState } = this.props;
    const {
      component = {},
      vulnerabilities = [],
      isLoadingComponent = false,
      isLoadingVulnerabilities = false,
      vulnerabilityFetchError = false,
      cvss,
    } = libraryState;
    const { libraryModel = {} } = component;
    const { id, name = '' } = libraryModel;
    let vulnElements = [];
    const vulnFilter = libraryState.vulnerabilityFilter;
    const filteredVulnerabilities = this.getFilteredVulnerabilities() || [];
    const isCvss3Selected = cvss === 'cvss3' && CvssService.isCvss3Enabled();
    const sortedVulnerabilities = _.sortBy(filteredVulnerabilities, vuln => {
      const { srcclrCvss3Score, nvdCvss3Score, srcclrCvssScore, nvdCvssScore } = vuln;
      const cvssScore = isCvss3Selected
        ? Helpers.getFirstNonNull([nvdCvss3Score, srcclrCvss3Score])
        : Helpers.getFirstNonNull([nvdCvssScore, srcclrCvssScore]);
      return cvssScore;
    }).reverse();
    let vulnListContent;
    sortedVulnerabilities.forEach(vuln => {
      const {
        id: vulnId,
        title,
        language,
        srcclrCvss3Score,
        nvdCvss3Score,
        srcclrCvssScore,
        nvdCvssScore,
      } = vuln;
      const artifactUrl = StringService.createSEOVulnItemUrl(title, language, vulnId);
      const artifactComponents = vuln.artifactComponents;
      const artifactComponent =
        _.find(artifactComponents, artComp => {
          return artComp.componentId === id;
        }) || {};
      const versionRanges = artifactComponent.versionRanges || [];
      const cvssScore = isCvss3Selected
        ? Helpers.getFirstNonNull([nvdCvss3Score, srcclrCvss3Score])
        : Helpers.getFirstNonNull([nvdCvssScore, srcclrCvssScore]);
      const cvssVectorLevel = isCvss3Selected
        ? CvssService.getCvss3Severity(cvssScore)
        : CvssService.getCvssSeverity(cvssScore);
      const riskColorClass = CvssService.getRiskColorClassByVectorLevel(cvssVectorLevel);
      const affectedRanges =
        versionRanges.map(range => {
          if (range.versionRange !== 'HEAD') {
            return range.versionRange.split(',').join(', ');
          }
          const startCommit = range.startCommit && range.startCommit.slice(0, 7);
          const endCommit = range.endCommit && range.endCommit.slice(0, 7);
          return `${startCommit}-${endCommit}`;
        }) || [];
      const rangeDisplay = affectedRanges.join(', ');
      const formattedDisclosureDate = vuln.disclosureDate
        ? Helpers.formatDate(vuln.disclosureDate)
        : 'n/a';
      vulnElements.push(
        <Tr key={`${vulnId}-${title}`}>
          <Td column="severity">
            <div
              className={`text--center color--white pv-- phone--pl0 phone--pr0 ${riskColorClass}`}
            >
              {cvssScore}
            </div>
          </Td>
          <Td column="issue">
            <div className="col-9-10">
              <Link className="link--primary" to={artifactUrl}>
                {title}
              </Link>
            </div>
          </Td>
          <Td column="date-known">{formattedDisclosureDate}</Td>
          <Td column="versionOrCommitHash">{rangeDisplay}</Td>
        </Tr>
      );
    });
    const table = (
      <Table
        className="reactable-table reactable-vuln-history min-height--205"
        id="reactable-vuln-history"
        itemsPerPage={4}
        pageButtonLimit={10}
        hideFilterInput
        noDataText="No vulnerabilities found."
      >
        <Thead>
          <Th column="severity" className="col-1-10">
            <strong>Severity</strong>
          </Th>
          <Th column="issue" className="col-5-10">
            <strong>Issue</strong>
          </Th>
          <Th column="date-known" className="col-1-10">
            <strong>Date Known</strong>
          </Th>
          <Th column="versionOrCommitHash" className="col-3-10">
            <strong>Version Range or Commit Hash</strong>
          </Th>
        </Thead>
        {vulnElements}
      </Table>
    );
    if (isLoadingComponent || isLoadingVulnerabilities || !vulnerabilities) {
      vulnListContent = (
        <div className="grid pb+">
          <div className="grid__item col-1-1">Fetching vulnerabilities...</div>
        </div>
      );
    } else if (vulnerabilityFetchError) {
      vulnListContent = (
        <div className="grid pb+">
          <div className="grid__item col-1-1">Error fetching vulnerabilities</div>
        </div>
      );
    } else if (vulnerabilities && vulnerabilities.length) {
      vulnListContent = (
        <div className="grid pb+">
          <div className="grid__item col-1-1">
            <input
              name="vulns"
              className="col-1-3 phone--col-1-1"
              type="text"
              placeholder="Filter vulnerabilities by issue"
              defaultValue={vulnFilter}
              onChange={this.updateFilter}
              autoFocus
            />
          </div>
          <div className="grid__item col-1-1 mt">{table}</div>
        </div>
      );
    } else if (vulnerabilities && !vulnerabilities.length) {
      vulnListContent = (
        <div className="grid pb+">
          <div className="grid__item col-1-1">No vulnerabilities found for {name}</div>
        </div>
      );
    }
    return <section>{vulnListContent}</section>;
  }
}
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
    vcPageState: state.vcPageState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(libraryActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewVulnerabilities);
